import { vansiteUpdateTransactionMetadata } from '../util/api';
import { storableError } from '../util/errors';
import { fetchCurrentUser } from './user.duck';

// ================ Action types ================ //

export const UPDATE_TRANSACTION_REQUEST = 'app/TransactionPage/UPDATE_TRANSACTION_REQUEST';
export const UPDATE_TRANSACTION_SUCCESS = 'app/TransactionPage/UPDATE_TRANSACTION_SUCCESS';
export const UPDATE_TRANSACTION_ERROR = 'app/TransactionPage/UPDATE_TRANSACTION_ERROR';

// ================ Reducer ================ //

/** @type {import('../../types/vansite').VanSite.State.Transaction} */
const initialState = {
  updateTransactionInProgress: false,
  updateTransactionError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_TRANSACTION_REQUEST:
      return { ...state, updateTransactionInProgress: true, updateTransactionError: null };
    case UPDATE_TRANSACTION_SUCCESS:
      return { ...state, updateTransactionInProgress: false };
    case UPDATE_TRANSACTION_ERROR:
      return { ...state, updateTransactionError: payload, updateTransactionInProgress: false };
    default:
      return state;
  }
}

export const updateTransactionRequest = () => ({
  type: UPDATE_TRANSACTION_REQUEST,
});

export const updateTransactionSuccess = () => ({
  type: UPDATE_TRANSACTION_SUCCESS,
});

export const updateTransactionError = (e) => ({
  type: UPDATE_TRANSACTION_ERROR,
  payload: e,
});

// ================ Thunks ================ //

export const updateTransaction = (params) => async (dispatch) => {
  dispatch(updateTransactionRequest());
  try {
    const { id, metadata } = params;
    const response = await vansiteUpdateTransactionMetadata({ id, metadata });
    dispatch(updateTransactionSuccess());
    dispatch(fetchCurrentUser());
    return response;
  } catch (e) {
    dispatch(updateTransactionError(storableError(e)));
  }
};
